import {
  prepareRequest
} from './request'
import SettingsManager from '../managers/settings'

export const fetchGameDetails = (gameId) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'GET',
    url: 'gs/getUrl',
    query: {
      game: gameId,
      locale: lang
    }
  })

  return request()
}

export const fetchDemoGameDetails = (gameId) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'GET',
    url: 'gs/getDemoUrl',
    query: {
      game: gameId,
      locale: lang
    }
  })

  return request()
}

export const fetchTVGameDetails = () => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'GET',
    url: 'gs/getTvGamesUrl',
    query: {
      locale: lang
    }
  })

  return request()
}

export const fetchGames = (options) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'gs/games',
    query: {
      locale: lang
    }
  })

  return request(options)
}

export const fetchFavoriteGames = (options) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'gs/favorites:find',
    query: {
      locale: lang
    }
  })

  return request(options)
}

export const addToFavorites = (options) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'gs/favorites:add'
  })

  return request(options)
}

export const removeFromFavorites = (options) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'gs/favorites:remove'
  })

  return request(options)
}

export const fetchProviders = (options) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'gs/providers:find',
    query: {
      locale: lang
    }
  })

  return request(options)
}

export const fetchCategories = (options) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'gs/categories',
    query: {
      locale: lang
    }
  })

  return request(options)
}

export const fetchGameTypes = (options) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'POST',
    url: 'gs/gameTypes:find',
    query: {
      locale: lang
    }
  })

  return request(options)
}

export const getCasinoHistory = options => {
  const request = prepareRequest({
    method: 'POST',
    url: 'gs/gameRounds'
  })

  return request(options)
}
